import React, { ReactElement, useContext } from 'react';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { Immutable } from '@wds/utils';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute } from '@sm/metrics';
import { SubMenuItem } from '../mobile-nav/SubMenuItem';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';

type MenuItemType = Immutable<{
  title: string;
  url: string;
  subTitle: string;
  openInNewWindow?: boolean;
}>;

const MenuItems = ({
  title,
  url,
  subTitle,
  openInNewWindow = false,
}: MenuItemType): ReactElement => {
  const classes = useStyles();
  const { pageURL, pageURLPath } = useContext(HeaderContext);
  const metrics = generateMetricsAttribute({
    data: {
      url: pageURL,
      pageName: pageURLPath,
      amplitudeEvent: 'header clicked navigation',
      navItem: title.toLowerCase(),
    },
  });
  return (
    <Responsive minWidth="xl">
      {matches =>
        matches ? (
          <List.Item
            interactive
            noRules
            isNavigable
            href={url}
            data-sm-metrics={metrics}
            {...(openInNewWindow === true && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
          >
            <Box py={4}>
              <Typography variant="body">{title}</Typography>
              <Box pt={1} display="flex" className={classes.descriptionBox}>
                <Typography variant="bodySm">{subTitle}</Typography>
              </Box>
            </Box>
          </List.Item>
        ) : (
          <SubMenuItem title={title} url={url} metrics={metrics} />
        )
      }
    </Responsive>
  );
};

export default MenuItems;
export { MenuItems };
